module.exports = __webpack_public_path__ + "static/media/gd.d342e327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gd.png
// module id = 1856
// module chunks = 0